/**
 * `data-type="zoom"` is on by default in generated HTML (images, video, model).
 * It is omitted only when `zoom.enable:false` is explicitly set in options.
 * Spin slides never get `data-type="zoom"`.
 */
const combinedOptions = (options = "", optionsMobile = "") => {
  return [options, optionsMobile].filter(Boolean).join(" ");
};

/**
 * @returns {string} `' data-type="zoom"'` or `""`
 */
export const getDataTypeZoomAttribute = (options = "", type = "", optionsMobile = "") => {
  const c = combinedOptions(options, optionsMobile);
  if (type === "panorama" || type === "spins") {
    return "";
  }
  if (c.includes("zoom.enable:false")) {
    return "";
  }
  return ' data-type="zoom"';
};

export const zoomHTMLString = (options = "", type = "", optionsMobile = "") => {
  if (getDataTypeZoomAttribute(options, type, optionsMobile) === "") return "";
  return (
    ' <span style="color: #606;">data-type</span><span style="color: #660;">=</span>' +
    '<span style="color:#080;">"zoom"</span>'
  );
};
